/**
 * @param {HTMLElement} DOMRef
 * @return {Number}
 */
export default (DOMRef) => {
  if (!DOMRef) {
    return
  }

  const { clientHeight } = DOMRef
  const { marginTop, marginBottom, borderTopWidth, borderBottomWidth } = getComputedStyle(DOMRef)

  return (
    clientHeight +
    parseInt(marginTop) +
    parseInt(marginBottom) +
    parseInt(borderTopWidth) +
    parseInt(borderBottomWidth)
  )
}
